import Vue from 'vue';
const isServer = Vue.prototype.$isServer;

export default { 
    hasClass( elements,cName ){ 
        return !!elements.className.match( new RegExp( "(\\s|^)" + cName + "(\\s|$)") ); 
    },
    addClass( elements,cName ){ 
        if( !this.hasClass( elements,cName ) ){ 
            elements.className += " " + cName; 
        }; 
    },
    removeClass( elements,cName ){ 
        if( this.hasClass( elements,cName ) ){ 
            elements.className = elements.className.replace( new RegExp( "(\\s|^)" + cName + "(\\s|$)" ), " " );
        }; 
    },
    removeListClass(eList,cName){
        let self=this
        for(let i=0;i<eList.length;i++){
            self.removeClass(eList[i],cName)
        }
    },
    parseDom(arg) {
        var objE = document.createElement("div");
        objE.innerHTML = arg;
        return objE.childNodes;
    },
    //开启loading
    addServiceLoading(){
        let loadingDom=document.getElementById("serviceLoading")
        if(!loadingDom){
            loadingDom=this.parseDom('<div id="serviceLoading" class="ivu-modal-mask" style=""></div>')
            document.body.append(loadingDom[0])
        }else{
            this.removeClass(loadingDom,"close-loading")
        }
    },
    //关闭loading
    closeServiceLoading(){
        let loadingDom=document.getElementById("serviceLoading")
        if(loadingDom)this.addClass(loadingDom,"close-loading")
    },
}

/* istanbul ignore next */
export const on = (function() {
    if (!isServer && document.addEventListener) {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false);
            }
        };
    } else {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.attachEvent('on' + event, handler);
            }
        };
    }
})();

/* istanbul ignore next */
export const off = (function() {
    if (!isServer && document.removeEventListener) {
        return function(element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false);
            }
        };
    } else {
        return function(element, event, handler) {
            if (element && event) {
                element.detachEvent('on' + event, handler);
            }
        };
    }
})();

 
 


// WEBPACK FOOTER //
// ./src/utils/dom.js